<template>
  <div
    class="add-item"
  >
    <el-button
      :disabled="disabled"
      icon="el-icon-plus"
      size="mini"
      @click="addProduct"
    >
      Termék hozzáadása
    </el-button>
    <el-button
      v-if="displayAddService"
      :disabled="disabled"
      icon="el-icon-plus"
      size="mini"
      @click="addService"
    >
      Szolgáltatás hozzáadása
    </el-button>
    <el-button
      v-if="displayAddFreeWordItem"
      :disabled="disabled"
      icon="el-icon-plus"
      size="mini"
      @click="addFreeWordItem"
    >
      Szabadszavas tétel hozzáadása
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    displayAddService: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    displayAddFreeWordItem: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
  },
  methods: {
    addProduct() {
      this.$emit('addProduct');
    },
    addService() {
      this.$emit('addService');
    },
    addFreeWordItem() {
      this.$emit('addFreeWordItem');
    },
  },
};
</script>
